<template>
  <Teleport to="body">
    <!-- z-[1200] so a toast raised while a modal is open still reads: it has to clear the whole
         stack - MerchantBasket's z-500, the z-999 MarketingPopup, the z-1000 sheets, and
         Overlay.vue's z-[1100] product modal - and both this and Overlay Teleport to body.
         The pill must clear the basket bar entirely: a toast is raised by the very act of adding
         something, which is exactly the moment a customer reaches for "Proceed to checkout"
         underneath it. A constant offset cannot do that - the bar's slot carries the pricing-tier
         progress and cycle banners, so bottom-24 cleared it on a plain V1 store and still sat on it
         wherever those render. MerchantBasket publishes its measured height instead; the 0px
         fallback covers the routes that have no basket at all. Nothing in the pill is clickable, so
         the whole stack stays pointer-events-none rather than swallowing that tap. -->
    <div
      v-if="toasts.length > 0"
      data-testid="toast-host"
      class="toast-host-offset fixed left-1/2 transform -translate-x-1/2 z-[1200] flex flex-col items-center gap-2 w-full max-w-sm px-4 pointer-events-none"
    >
      <!-- No `w-full`: the pill hugs its message rather than stretching to the host's max width. -->
      <Toast v-for="toast in toasts" :key="toast.id" :message="toast.message" :type="toast.type" />
    </div>
  </Teleport>
</template>

<script>
import Toast from '@/components/Molecules/Toast'
import { useToasts } from '@/composables/useToasts'

export default {
  name: 'ToastHost',
  components: {
    Toast
  },
  setup() {
    // Removal is the timer's job (useToasts auto-dismisses after DEFAULT_TOAST_TIMEOUT); the pill
    // carries no close button, so the host has nothing to wire.
    const { toasts } = useToasts()

    return { toasts }
  }
}
</script>

<style scoped>
/* A real rule rather than an inline style or a Tailwind arbitrary value: the comma in the var()
   fallback is not something the class parser handles predictably, and an inline calc(var(...)) is
   at the mercy of whatever CSS parser is reading it. MerchantBasket sets the variable from its own
   measured height; the fallback keeps the pill off the very bottom edge on routes with no basket. */
.toast-host-offset {
  bottom: calc(var(--merchant-basket-height, 0px) + 1rem);
}
</style>
